<template>
  <div class="d-flex align-start ga-2">
    <v-icon size="24" color="#BD9478" :icon="icon" />
    <div class="d-flex flex-column align-start ga-0">
      <div class="d-flex align-center">
        <span class="key">{{ title }}</span>
      </div>
      <div class="d-flex ga-2 align-center">
        <span v-if="numberOne !== null" class="money-value"
          >₪{{ Number(numberOne).toLocaleString() }}</span
        >
        <span v-if="numberTwo" style="font-size: 14px">{{
          $t("AccountPage.UserAccoutingItem.ofPrice")
        }}</span>
        <span v-if="numberTwo" class="money-value"
          >₪{{ Number(numberTwo).toLocaleString() }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    numberOne: {
      type: Number,
    },
    numberTwo: {
      type: Number,
    },
    icon: {
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
.key {
  color: var(--black, $statusListColor);
  font-size: $mediumTextSize;
  font-weight: 400;
}

.money-value {
  color: var(--black, $statusListColor);
  font-size: $mediumTextSize;
  font-weight: 700;
}
</style>
